export default __webpack_public_path__ + "static/media/register_doctor.2285487f.png";